export enum UserAuctionEligibleStatus{
  INCOMPLETE = "INCOMPLETE",
  AWAITING_APPROVAL = "AWAITING_APPROVAL",
  REJECTED_BIDDERS = "REJECTED_BIDDERS",
  APPROVED_BIDDERS = "APPROVED_BIDDERS",
}
